const dev = {
  API_ENDPOINT_URL: 'https://node.sightbuilder.pro/app'
	// API_ENDPOINT_URL : 'http://localhost:7082/app'
};

const prod = {
  API_ENDPOINT_URL: 'https://node.sightbuilder.pro/app'
};

const test = {
  API_ENDPOINT_URL: 'https://node.sightbuilder.pro/app'
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			return prod 
	}
}

export const env = getEnv()
